import { render, staticRenderFns } from "./DomainDnssecDisableConfirmation.vue?vue&type=template&id=74150c0f&"
import script from "./DomainDnssecDisableConfirmation.vue?vue&type=script&lang=js&"
export * from "./DomainDnssecDisableConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports